export default async function init() {
  const quotes = document.querySelectorAll('[data-js-module="quote"]');

  const initQuote = async () => {
    const { default: Quote } = await import(/* webpackChunkName: "quote" */ './quote');
    quotes.forEach((notification) => new Quote(notification));
  };

  if (quotes.length) initQuote();
}

init();
